<div class="row row_main" *ngIf="step == 1 || step == 2 || step == 3">

  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn" style="margin: 30px 0">
    <h1 class="titulo-simpli">Comienza tu simulación</h1>
    <small class="subtitulo-simpli">Descubre cómo puede crecer tu inversión con nosotros</small>
  </div>

  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 animate__animated animate__fadeIn" id="formContainer" #formContainer>

    <mat-card *ngIf="step == 1" class="mtb">
      <mat-card-content>

        <div class="row">

          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" *ngIf="subStep == 1">
            <form [formGroup]="valForm">

              <div class="row">
                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field class="readonly-field">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" required (input)="capitalizeName()" />
                    <mat-hint>El nombre no se puede modificar</mat-hint>
                    <mat-error *ngIf="valForm.controls['name'].hasError('required')">
                      Nombre es <strong>requerido</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field class="readonly-field">
                    <mat-label>Correo electrónico</mat-label>
                    <input matInput formControlName="mail" type="email" required (input)="convertToLowerCase($event)" />
                    <mat-hint>El correo electrónico no se puede modificar</mat-hint>
                    <mat-error *ngIf="valForm.controls['mail'].hasError('required')">
                      Correo electrónico es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="valForm.controls['mail'].hasError('email')">
                      Correo electrónico no es <strong>válido</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field>
                    <mat-label>RUT</mat-label>
                    <input matInput  formControlName="rut" (input)="formatRUT($event)" required />
                    <mat-hint>{{ valForm.get('rut')?.value ? 'Ingrese RUT' : 'Ingrese RUT' }}</mat-hint>
                    <mat-error *ngIf="valForm.controls['rut'].hasError('required')">
                      RUT es <strong>requerido</strong>
                    </mat-error>
                    <mat-error
                      *ngIf="valForm.controls['rut'].hasError('invalidRUT') && !valForm.controls['rut'].hasError('required')">
                      RUT no es <strong>válido</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field>
                    <input matInput type="text" maxlength="9" formControlName="telefono" placeholder="Teléfono"
                      required>
                    <span matTextPrefix>+56&nbsp;</span>
                    <mat-hint>Ingrese el número de 9 dígitos del contacto.</mat-hint>
                    <mat-error *ngIf="valForm.controls['telefono'].hasError('required')">
                      Teléfono es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="valForm.controls['telefono'].hasError('pattern')">
                      El número de teléfono debe ser de <strong>9 dígitos</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </form>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" *ngIf="subStep == 2">
            <form [formGroup]="formGroup">
              <div class="row">

                <div class="col-md-6 col-sm-6 col-xs-12  col-top">
                  <mat-form-field>
                    <!-- <mat-label>Monto</mat-label> -->
                    <input placeholder="Monto" matInput type="text" (keyup)="formatMonto($event)"
                      formControlName="monto" required>
                    <span matTextPrefix>$&nbsp;</span>
                    <mat-hint>Indique el monto</mat-hint>
                    <mat-error *ngIf="formGroup.controls['monto'].hasError('required')">
                      Monto es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['monto'].hasError('invalidMonto')">
                      Monto es <strong>inválido</strong>
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['monto'].hasError('montoMinimo')">
                      Monto debe ser al menos <strong>$500.000</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field>
                    <mat-label>Fecha emisión</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="fechaEmision" required />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-hint>Seleccione la fecha de emisión</mat-hint>
                    <mat-error *ngIf="formGroup.controls['fechaEmision'].hasError('required')">
                      Fecha de emisión es <strong>requerida</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field>
                    <mat-label>Plazo (meses)</mat-label>
                    <input matInput formControlName="plazo" type="number" (wheel)="$event.preventDefault()" required />
                    <mat-hint>Indique el plazo en meses</mat-hint>
                    <mat-error *ngIf="formGroup.controls['plazo'].hasError('required')">
                      Plazo es <strong>requerido</strong>
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['plazo'].hasError('pattern')">
                      El plazo debe ser un <strong>número entero</strong>
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls['plazo'].hasError('min')">
                      El plazo debe ser mínimo <strong>3 meses</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field>
                    <mat-label>Retiro</mat-label>
                    <mat-select formControlName="retiro" required>
                      <mat-option value="Mensual">Mensual</mat-option>
                      <mat-option value="Al vencimiento">Al vencimiento</mat-option>
                    </mat-select>
                    <mat-hint>Seleccione el tipo de retiro</mat-hint>
                    <mat-error *ngIf="formGroup.controls['retiro'].hasError('required')">
                      Tipo de retiro es <strong>requerido</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field class="hidden">
                    <mat-label>Cliente</mat-label>
                    <mat-select formControlName="cliente" required>
                      <mat-option value="Interno">Interno</mat-option>
                      <mat-option value="Externo">Externo</mat-option>
                    </mat-select>
                    <mat-hint>Seleccione el tipo de cliente</mat-hint>
                    <mat-error *ngIf="formGroup.controls['cliente'].hasError('required')">
                      Tipo de cliente es <strong>requerido</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 col-top">
                  <mat-form-field class="hidden">
                    <mat-label>Tasa (opcional)</mat-label>
                    <input matInput type="number" formControlName="tasa">
                    <mat-hint>Ingrese una tasa con hasta 4 decimales.</mat-hint>
                    <mat-error *ngIf="formGroup.controls['tasa'].hasError('maxFourDecimals')">
                      La tasa debe tener como máximo <strong>4 decimales</strong>
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>
            </form>
          </div>

        </div>

        <div class="btn-container">

          <button mat-flat-button class="primary-button mt-20" type="button" *ngIf="subStep == 1"
            (click)="siguiente_paso($event, this.valForm.value, 1)" [ngClass]="{'hidden': hideBtn}">Siguiente</button>

          <button mat-flat-button class="secondary-button mt-5" type="button" *ngIf="subStep == 2" (click)="goToPreviousStep()">Anterior</button>

          <button mat-flat-button class="primary-button mt-5" type="button" *ngIf="subStep == 2"
            (click)="siguiente_paso($event, this.formGroup.value, 2)" [disabled]="enviandoBtn">
            <span *ngIf="!enviandoBtn">Siguiente</span>
            <span *ngIf="enviandoBtn"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
          </button>

        </div>


      </mat-card-content>
    </mat-card>



    <div *ngIf="step == 2" style="margin-bottom: 20px;">
      <app-resultado-simulacion [stepper]="stepper" [parent]="this" />
    </div>

    <div div *ngIf="step == 3">
      <app-pdf-simulacion [stepper]="stepper" />
    </div>


  </div>
</div>